import IndividualGradient from 'svg/IndividualGradient';
import NoPeople from 'svg/NoPeople';
import PlusPlain from 'svg/PlusPlain';
import classNames from 'styles/utils/classNames';

interface Props {
  className?: string;
  /**
   * Colour for the monochrome glyphs + label. The waving-person glyph keeps its
   * baked lime gradient regardless.
   */
  toneClassName?: string;
}

/**
 * The "Find players" lockup: waving person + racket player over the label. Shared
 * by the home banner (inverted, on fire) and the Find players onboarding header.
 */
export default function FindPlayersLockup({
  className,
  toneClassName = 'text-color-text-lightmode-primary dark:text-color-text-darkmode-primary',
}: Props) {
  return (
    <div className={classNames('flex flex-col items-center gap-ds-sm', toneClassName, className)}>
      <span className="flex items-center gap-ds-xs">
        <IndividualGradient className="h-8 w-8 shrink-0" />
        <PlusPlain className="h-6 w-6 shrink-0" />
        <NoPeople className="h-8 w-8 shrink-0" />
      </span>
      <span className="typography-product-heading-mobile">Find players</span>
    </div>
  );
}
